<template>
  <div class="comprehensive-form-container">
    <el-row :gutter="20">
      <el-col
        :lg="{ span: 12, offset: 6 }"
        :md="{ span: 20, offset: 2 }"
        :sm="{ span: 20, offset: 2 }"
        :xl="{ span: 12, offset: 6 }"
        :xs="24"
      >
        <el-form
          ref="form"
          class="demo-form"
          :label-position="labelPosition"
          label-width="100px"
          :model="form"
          :rules="rules"
        >
          <el-form-item label="customer" prop="customer">
            <el-input v-model.trim="form.customer" />
          </el-form-item>
          <el-form-item label="key" prop="key">
            <el-input v-model.trim="form.key" show-password />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('form')">
              保存
            </el-button>
            <el-button @click="resetForm('form')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { getKuaiDi100Config, setupKuaiDi100 } from '@/api/settings'
  export default {
    name: 'Express100',
    data() {
      return {
        labelPosition: 'right',
        form: {
          customer: '',
          key: '',
        },
        rules: {
          customer: [],
          key: [],
        },
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      async getData() {
        const ret = await getKuaiDi100Config()
        if (!ret) return
        this.form.customer = ret.basic.customer
        this.form.key = ret.basic.key
      },
      submitForm(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            await setupKuaiDi100({
              config: this.form,
            })
            this.getData()
            this.$message.success('保存快递100配置成功')
          } else {
            this.$message.success('保存快递100配置失败')
            return false
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      },
    },
  }
</script>

<style lang="scss" scoped>
  ::v-deep {
    .el-form-item__content {
      .el-rate {
        display: inline-block;
        font-size: 0;
        line-height: 1;
        vertical-align: middle;
      }

      .el-transfer__buttons {
        padding: 10px 10px 0 10px;
      }
    }
  }
  .title {
    color: #c3c3c3;
    padding-bottom: 10px;
    border-bottom: 1px solid #e3e3e3;
  }
</style>
